import React, { useState, useEffect, useRef } from 'react';
import api from '../utils/api';

const BarnPicker = ({ value, onChange, onPick, placeholder }) => {
  const [options, setOptions] = useState(null);
  const [open, setOpen] = useState(false);
  const filled = useRef(false);
  const boxRef = useRef(null);
  const valueRef = useRef(value);
  valueRef.current = value;

  useEffect(() => {
    let ok = true;
    const run = async () => {
      const opts = [];
      for (const ep of ['/organizations/mine', '/organizations', '/memberships/mine']) {
        try {
          const r = await api.get(ep);
          const list = Array.isArray(r.data) ? r.data : (r.data.organizations || r.data.orgs || []);
          if (list.length) {
            list.forEach(o => {
              const org = o.organization || o;
              if (org && org.name) opts.push({ name: org.name, location: org.location || '', tag: 'your barn' });
            });
            break;
          }
        } catch (e) {}
      }
      try {
        const r = await api.get('/horses');
        const horses = Array.isArray(r.data) ? r.data : (r.data.horses || []);
        horses.forEach(h => {
          if (h.barn_name && !opts.some(o => o.name.toLowerCase() === h.barn_name.toLowerCase())) {
            opts.push({ name: h.barn_name, location: h.barn_location || '', tag: '' });
          }
        });
      } catch (e) {}
      if (!ok) return;
      setOptions(opts);
      if (!filled.current && opts.length && !(valueRef.current || '').trim()) {
        filled.current = true;
        onPick(opts[0]);
      }
    };
    run();
    return () => { ok = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const onDown = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, []);

  const q = (value || '').trim().toLowerCase();
  const matches = (options || []).filter(o => !q || o.name.toLowerCase().includes(q));
  const exact = matches.some(o => o.name.toLowerCase() === q);

  return (
    <div ref={boxRef} style={{ position: 'relative' }}>
      <input
        className="form-input"
        type="text"
        value={value}
        placeholder={placeholder}
        autoComplete="off"
        onChange={(e) => { onChange(e); setOpen(true); }}
        onFocus={() => setOpen(true)}
      />
      {open && options && (matches.length > 0 || (q && !exact)) && (
        <div style={{ position: 'absolute', left: 0, right: 0, top: '100%', marginTop: 4, background: '#fff', border: '1px solid var(--border-color)', borderRadius: 10, boxShadow: '0 8px 20px rgba(51,0,29,0.14)', zIndex: 40, maxHeight: 220, overflowY: 'auto' }}>
          {matches.slice(0, 6).map((o, i) => (
            <div key={o.name + i}
              onMouseDown={(e) => { e.preventDefault(); onPick(o); setOpen(false); }}
              style={{ padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid rgba(38,25,31,0.06)', display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 600 }}>{o.name}</div>
                {o.location ? <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{o.location}</div> : null}
              </div>
              {o.tag ? <span style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: '0.04em', color: '#4B002B', background: '#F1EAE0', borderRadius: 99, padding: '3px 8px' }}>{o.tag.toUpperCase()}</span> : null}
            </div>
          ))}
          {q && !exact && (
            <div style={{ padding: '9px 12px', fontSize: 12, color: 'var(--text-secondary)' }}>
              {'New barn \u2014 saved with this horse and offered next time'}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default BarnPicker;
